import Form from "@rjsf/core";
import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import PrwAcceptTermsOfServices from "../../../ui/widgets/form/PrwAcceptTermsOfServices";
import PrwCheckbox from "../../../ui/widgets/form/PrwCheckbox";
import PrwCountryDropdown from "../../../ui/widgets/form/PrwCountryDropdown";
import PrwDropdownBasic from "../../../ui/widgets/form/PrwDropdownBasic";
import PrwImageUpload from "../../../ui/widgets/form/PrwImageUpload";
import PrwInputText from "../../../ui/widgets/form/PrwInputText";
import PrwInputTextArea from "../../../ui/widgets/form/PrwInputTextArea";
import PrwPassword from "../../../ui/widgets/form/PrwPassword";
import PrwPhoneNumber from "../../../ui/widgets/form/PrwPhoneNumber";
import PrwReCaptcha from "../../../ui/widgets/form/PrwReCaptcha";
import PrwToggleButton from "../../../ui/widgets/form/PrwToggleButton";

const DynamicForm = React.forwardRef((props: any, ref: any) => {
  const { schema, uiSchema, validationSchema, formData, formButtons } = props;
  const { t } = useTranslation();
  const [liveValidate, setLiveValidate] = useState(false);

  const validatorWrapper = (
    formData: any,
    errors: any,
    validationSchemaLocal: any = validationSchema
  ) => {
    if (validationSchemaLocal) {
      for (let field in validationSchemaLocal) {
        let obj = validationSchemaLocal[field];
        let validators = obj.validators as any[];
        if (!!obj.validators && validators.length > 0) {
          for (let item of validators) {
            let value = formData[field];
            let isValid = item.validate(value);

            if (isValid === false) {
              errors[field].addError(t(item.messageKey));

              // Show only one error message at a time.
              break;
            }
          }
        } else {
          // This is required when we have nested object structure.
          validatorWrapper(
            formData[field],
            errors[field],
            validationSchemaLocal[field]
          );
        }
      }
    }

    return errors;
  };

  const transformErrors = (errors: any) => {
    return errors.map((error: any) => {
      if (error.name === "required" || error.name === "type") {
        error.message = null;
      }
      return error;
    });
  };

  const widgets = {
    prwInputText: PrwInputText,
    prwPassword: PrwPassword,
    prwDropdownBasic: PrwDropdownBasic,
    prwCountryDropdown: PrwCountryDropdown,
    prwReCaptcha: PrwReCaptcha,
    prwAcceptTermsOfServices: PrwAcceptTermsOfServices,
    prwImageUpload: PrwImageUpload,
    prwInputTextArea: PrwInputTextArea,
    prwPhoneNumber: PrwPhoneNumber,
    prwCheckbox: PrwCheckbox,
    prwToggleButton: PrwToggleButton
  };

  const handleOnChange = (e: any) => {
    props.onChange(e.formData);
  };

  const handleError = (e: any) => {
    setLiveValidate(true);
    props.onError(e);
  };

  return (
    <>
      <Form
        ref={ref}
        schema={schema}
        uiSchema={uiSchema}
        widgets={widgets}
        formData={formData}
        onChange={(e) => {
          handleOnChange(e);
        }}
        validate={validatorWrapper}
        transformErrors={transformErrors}
        showErrorList={false}
        liveValidate={liveValidate}
        noHtml5Validate
        onSubmit={props.onSubmit}
        onError={handleError}
        additionalMetaSchemas={[]}
        // ref={props.form}
      >
        {formButtons ? formButtons() : null}
      </Form>
</>
  );
});

export default DynamicForm;
